/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react'
import {
  consumptionModel,
  LoadFromModal
} from '../../../../../domain/models/billing-models'
import { IconDownloadSvg } from '../../../../assets/icons/svgComponents'
import {
  Button,
  EmptyData,
  SelectInputSearch,
  Table
} from '../../../../components'
import * as S from './styles'
type Props = {
  header?: string
  loadFromModal?: (period: string) => Promise<LoadFromModal>
}
export const BillingModal = ({ header, loadFromModal }: Props) => {
  const [period, setPeriod] = useState('')
  const [consumptionOptions, setconsumptionOptions] = useState<string[]>([])
  const [consumption, setConsumption] = useState<consumptionModel[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    load()
  }, [period])

  const load = async (): Promise<void> => {
    if (!loadFromModal) {
      setLoading(false)
      return
    }
    setLoading(true)
    const response = await loadFromModal(period)

    setconsumptionOptions(response.periods)
    setConsumption(response.consumition)
    setLoading(false)
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Data',
        accessor: 'dataConsumo',
        style: {
          width: '20%',
          minWidth: 120,
          boxShadow: 'unset'
        }
      },
      {
        Header: 'Nome',
        accessor: 'nomePaciente',
        style: {
          boxShadow: 'unset'
        }
      },
      {
        Header: 'Demanda',
        accessor: 'demandaServico',
        style: {
          boxShadow: 'unset'
        }
      }
    ],
    []
  )

  return (
    <S.Wrapper>
      <S.Header>
        <SelectInputSearch
          name=""
          placeholder="Selecione"
          wrapperClassName="date-select"
          options={consumptionOptions.map((item) => ({
            value: item,
            label: item
          }))}
          value={period ? { value: period, label: period } : undefined}
          onChange={(e) => setPeriod(e)}
          loading={loading}
        />
        <Button>
          <IconDownloadSvg />
        </Button>
      </S.Header>
      <S.Body>
        <S.DataContainer>
          {(loading || !!consumption.length) && (
            <Table
              columns={columns}
              dataTable={consumption}
              hasPagination={false}
            />
          )}

          {!loading && !consumption.length && (
            <EmptyData>Ainda não há {header}</EmptyData>
          )}
        </S.DataContainer>
      </S.Body>
    </S.Wrapper>
  )
}
